import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import isAvailable from "@Utils/isAvailable";
import wrapperHOC from "@Utils/wrapperHOC";
import SimilarProperties from ".";

const SimilarPropertiesWrapper = ({ isTopSection = false }) => {
  const { inventory } = useSelector(
    ({ propertyPageData }: AppState) => ({
      inventory: propertyPageData.data,
    }),
    shallowEqual,
  );
  const isPropertyAvailable = isAvailable(inventory);
  const isSoldOut = !isPropertyAvailable;

  return <>{isSoldOut && <SimilarProperties isTopSection={isTopSection} />}</>;
};

export default wrapperHOC(SimilarPropertiesWrapper, {
  componentName: "SimilarPropertiesWrapper-SearchPage",
  showForChina: true,
  showForWhiteLable: false,
});
